export default __webpack_public_path__ + "d819f7d4bda886c58b8471de82c8548f.png";